<!--Footer-->
<footer>
  <div class="container">
    <div class="main-footer">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-12">
          <div class="foot-about">
            <img
              src="assets/img/black-logo.png"
              data-aos="fade-right"
              data-aos-delay="200"
            />
            <p class="mb-0">
              EASWORKS connects exceptional companies with exceptional
              enterprise application developers & other talents.
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-12">
          <div class="foot-about">
            <h2>Customers</h2>
            <ul class="foot-type mb-0">
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Hire Developers
                </a>
              </li>
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Book a Call
                </a>
              </li>
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Hire for specific skills
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-12">
          <div class="foot-about">
            <h2>Get Hired</h2>
            <ul class="foot-type mb-0">
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Apply for Jobs
                </a>
              </li>
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Freelancer login
                </a>
              </li>
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Apply for specific skills
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-12">
          <div class="foot-about">
            <h2>Contact</h2>
            <ul class="foot-type mb-0">
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Blog
                </a>
              </li>
              <li class="foot-link">
                <a href="javascript:void(0)">
                  <i class="icofont-thin-right"></i>Contact Us
                </a>
              </li>
              <li class="foot-link">
                <a [routerLink]="['/help-center']">
                  <i class="icofont-thin-right"></i>Help Center
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="sub-footer">
      <p>© Copyright 2021 EASWORKS. All Rights Reserved.</p>
    </div>
  </div>
</footer>
